import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconShuffle: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconShuffle"><Path d="M2.5 18.5H4.5L16.5 6.5H21M2.5 5.5H4.5L8.5 9.5M21 17.5H16.5L13.5 14.5M18.5 3.5L21.5 6.5L18.5 9.5M18.5 14.5L21.5 17.5L18.5 20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconShuffle;
